import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import moment from "moment-timezone";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Grid,
  Paper,
} from "@material-ui/core";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import {
  setCurrentPage,
} from "actions";
import * as H from "helper";

const useStyles = makeStyles((theme) =>
  createStyles({
    gridSection: {
      marginTop: theme.spacing(1),
    },
    statsSection: {
      minHeight: 60,
      padding: theme.spacing(2),
      borderRadius: 4,
    },
    statBox: {
      marginTop: 0,
      minHeight: 60,
      paddingLeft: 8,
      borderRight: "1px solid #dcdcdc",
      "&:last-child": {
        borderRight: "none",
      },
    },
    summary: {
      marginRight: 60,
    },
    statTitle: {
      fontSize: 13,
      paddingBottom: 8,
    },
    dataBox: {
      minWidth: 150,
      marginRight: 16,
      marginBottom: 16,
      borderRight: "solid 1px #ccc"
    },
    dataTitle: {
      fontSize: 14,
      color: "#757575",
    },
    dataValue: {
      marginTop: 8,
      fontSize: 14,
    },
    rightBox: {

    },
  })
);

const MissionDetailSummary = ({
  setCurrentPage,
  pageTopLoader,
  campaignSelect,
  campaignMeta,
  dataSummary,
}) => {
  const classes = useStyles();

  return (
      <Grid
        container
        spacing={0}
        className={classes.gridSection}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={12} lg={10}>
          <Paper className={classes.statsSection}>
            <Grid
              container
              direction="row"
              className={classes.gridSection}
              justifyContent="flex-start"
            >
              <Grid
                className={classes.statBox}
                item
                xs={12}
              >
                <Grid
                  container
                  direction="row"
                  className={classes.gridSection}
                  justifyContent="flex-start"
                >
                  <Grid item xs={12} md={6} lg={12}>
                    <Grid
                      container
                      direction="row"
                      className={classes.summary}
                      justifyContent="flex-start"
                    >
                      <Grid item>
                        <div className={classes.dataBox}>
                          <div className={classes.dataTitle}>ステータス</div>
                          <div className={classes.dataValue}>
                            {dataSummary["missionTableData"] !== undefined && dataSummary["missionTableData"][0]["happening"]
                              ? "開催中"
                              : "終了"
                            }
                          </div>
                        </div>
                      </Grid>
                      <Grid item>
                        <div className={classes.dataBox}>
                          <div className={classes.dataTitle}>開催期間</div>
                          <div className={classes.dataValue}>
                            {dataSummary["missionTableData"] !== undefined && dataSummary["missionTableData"][0]["occurredDatetimeJst"]
                              ? `${dataSummary["missionTableData"][0]["occurredDatetimeJst"]} ~`
                              : "--"
                            }
                          </div>
                          <div className={classes.dataValue} fontSize={12}>
                            {dataSummary["missionTableData"] !== undefined && dataSummary["missionTableData"][0]["occurredDatetimeJst"]
                              ? `${dataSummary["missionTableData"][0]["endDatetimeJst"]}`
                              : ""
                            }
                          </div>
                        </div>
                      </Grid>
                      <Grid item>
                        <div className={classes.dataBox}>
                          <div className={classes.dataTitle}>初回達成所要（分）</div>
                          <div className={classes.dataValue}>
                            {dataSummary["missionTableData"] !== undefined && dataSummary["missionTableData"][0]["firstAchieveMin"]
                              ? H.FormatNumStrHelper.formatCommaThousand(dataSummary["missionTableData"][0]["firstAchieveMin"])
                              : "--"
                            }
                          </div>
                        </div>
                      </Grid>
                      <Grid item>
                        <div className={classes.dataBox}>
                          <div className={classes.dataTitle}>達成者数</div>
                          <div className={classes.dataValue}>
                            {dataSummary["missionTableData"] !== undefined && dataSummary["missionTableData"][0]["achieverCount"]
                              ? H.FormatNumStrHelper.formatCommaThousand(dataSummary["missionTableData"][0]["achieverCount"])
                              : "--"
                            }
                          </div>
                        </div>
                      </Grid>
                      <Grid item>
                        <div className={classes.dataBox}>
                          <div className={classes.dataTitle}>参加者数</div>
                          <div className={classes.dataValue}>
                            {dataSummary["missionTableData"] !== undefined && dataSummary["missionTableData"][0]["playerCount"]
                              ? H.FormatNumStrHelper.formatCommaThousand(dataSummary["missionTableData"][0]["playerCount"])
                              : "--"
                            }
                          </div>
                        </div>
                      </Grid>
                      <Grid item>
                        <div className={classes.dataBox}>
                          <div className={classes.dataTitle}>撮影枚数</div>
                          <div className={classes.dataValue}>
                            {dataSummary["missionTableData"] !== undefined && dataSummary["missionTableData"][0]["picCount"]
                              ? H.FormatNumStrHelper.formatCommaThousand(dataSummary["missionTableData"][0]["picCount"])
                              : "--"
                            }
                          </div>
                        </div>
                      </Grid>
                      <Grid item>
                        <div className={classes.dataBox}>
                          <div className={classes.dataTitle}>撮影基数</div>
                          <div className={classes.dataValue}>
                            {dataSummary["missionTableData"] !== undefined && dataSummary["missionTableData"][0]["assetCount"]
                              ? H.FormatNumStrHelper.formatCommaThousand(dataSummary["missionTableData"][0]["assetCount"])
                              : "--"
                            }
                          </div>
                        </div>
                      </Grid>

                    </Grid>
                  </Grid>

                  {/* Progress bar */}
                  <Grid item xs={12} md={6} lg={2}>
                    <Grid
                      container
                      direction="row"
                      className={classes.summary}
                      justifyContent="flex-start"
                    >
                      <Grid item>
                        <div className={classes.rightBox}>
                          {/* <div>プログレス</div> */}
                          {/* <div className={classes.dataValue}>0.8%</div> */}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>

                </Grid>
              </Grid>
            </Grid>

          </Paper>
        </Grid>
      </Grid>
  );
};

MissionDetailSummary.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  pageTopLoader: state.page.pageTopLoader,
  campaignSelect: state.a2e.campaignSelect,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(MissionDetailSummary));
